import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../analytics';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Log page view when location changes
    logPageView();
  }, [location]);
}; 